import { ICostResponse } from 'services/cash-flow/cost/types';
import { ICashFlowForm } from 'services/cash-flow/types';

export const costQueryToForm = (response: ICostResponse): ICashFlowForm => {
  const { costName, amount,id, ...cost } = {
    ...response,
    name: response.costName,
    amountGross: parseFloat(response.amount.grossAmount.toFixed(2)),
    amountNet: parseFloat(response.amount.netAmount.toFixed(2)),
    settlementId: response.settlementId ?? '',
    settlementName: response.settlementName ?? '',
    repayments: response.repayments ?? [],
    contracts: response.contracts?.map(c => ({id: c, name: ''})) ?? []
  };

  return cost;
};
